// extracted by mini-css-extract-plugin
export var content = "_au-3";
export var list = "_au-4";
export var settingsContent = "_au-7";
export var settingsPanel = "_au-8";
export var state = "_au-6";
export var triggerBadge = "_au-2";
export var triggerButton = "_au-1";
export var triggerShell = "_au-0";
export var unreadDot = "_au-5";